import { Clock, ShieldCheck, RefreshCw, Zap, Gift } from "lucide-react";
import { Card } from "@/components/ui/card";
const features = [{
  icon: Clock,
  title: "Housing Pressure",
  description: "Analyzing market demand and supply constraints across regions."
}, {
  icon: ShieldCheck,
  title: "Energy Security",
  description: "Evaluating grid stability and renewable transition metrics."
}, {
  icon: RefreshCw,
  title: "Transport Links",
  description: "Measuring connectivity and infrastructure efficiency levels."
}, {
  icon: Zap,
  title: "Cost of Living",
  description: "Tracking essential expenditure and purchasing power parity."
}, {
  icon: Gift,
  title: "Value for Money",
  description: "Assessing service quality relative to regional investment."
}];
export default function FeaturesFooter() {
  return <section data-section-id="253758" id="scoring-components" className="bg-background text-foreground py-8 border-t border-border">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-6">
          {features.map((feature, i) => <Card key={i} data-index={i} className="bg-white border-[0.5px] border-border shadow-none p-6 flex flex-row items-start gap-4 rounded-none hover:border-accent transition-colors duration-200 group">
              <div className="text-primary shrink-0 mt-1">
                <feature.icon className="w-6 h-6 stroke-[1]" />
              </div>
              <div className="flex flex-col gap-1.5">
                <h3 className="font-default font-semibold text-[20px] text-foreground leading-tight">
                  {feature.title}
                </h3>
                <p className="text-[14px] text-muted-foreground font-sans leading-snug">
                  {feature.description}
                </p>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}